export var ContentType;
(function (ContentType) {
    ContentType[ContentType["Json"] = 0] = "Json";
    ContentType[ContentType["Text"] = 1] = "Text";
    ContentType[ContentType["ArrayBuffer"] = 2] = "ArrayBuffer";
    ContentType[ContentType["Blob"] = 3] = "Blob";
})(ContentType || (ContentType = {}));
;
export function getMimeType(contentType) {
    switch (contentType) {
        case ContentType.Json:
            return "application/json";
        case ContentType.Text:
            return "text/plain";
        case ContentType.ArrayBuffer:
        case ContentType.Blob:
            return "application/octet-stream";
    }
    throw new Error();
}
//# sourceMappingURL=ContentType.js.map